<!--FastBI产品-->
<template>
  <div class="xz_buyDialog">
    <el-dialog :before-close="restForm" :title="isAdd == 'module' ? '增购模块' : '增购许可'" :visible.sync="visible"
      :close-on-click-modal="false" width="560px">
      <el-form :model="form" ref="form" :rules="formRules">
        <el-form-item :label-width="formLabelWidth" label="授权客户名称" prop="name">
          <el-input v-model="form.name" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" label="授权码" prop="code">
          <el-input v-model="form.code" :disabled="true"></el-input>
        </el-form-item>
        <!-- <el-form-item :label-width="formLabelWidth" label="授权码密码" prop="key">
          <el-input v-model="form.key" :disabled="true"></el-input>
        </el-form-item> -->
        <el-form-item v-if="isAdd == 'module'" :label-width="formLabelWidth" label="选择模块" prop="new_modules">
          <el-checkbox-group v-model="form.new_modules" @change="modules_change">
            <el-checkbox v-for="(item, index) in n_module" :key="index" :label="item.value">{{
              item.name
            }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="isAdd == 'user'" :label-width="formLabelWidth" label="增购用户数" prop="user_count">
          <el-input v-model="form.user_count"></el-input>
        </el-form-item>
        <el-form-item v-if="isAdd == 'module'" :label-width="formLabelWidth" label="购买方式" prop="buy_type">
          <el-radio-group v-model="form.buy_type" @change="buy_type_change">
            <el-radio :label="1">买断模式</el-radio>
            <el-radio :label="2">按年订阅</el-radio>
            <el-radio :label="3">申请试用</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item :label-width="formLabelWidth" v-if="form.buy_type == 2 && isAdd == 'module'" :label="'购买时长'">
          <el-input-number style="text-align: center;" size="small" v-model="form.new_months" :min="1" :max="100"
            :step="1"></el-input-number>
          <span style="margin-left: 10px;">年</span>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth" v-if="form.buy_type == 3 && isAdd == 'module'" :label="'试用时长'">
          <el-select v-model="form.trail_days" filterable placeholder="请选择">
            <el-option :key="7" label="七天" :value="7"> </el-option>
            <el-option :key="15" label="十五天" :value="15"> </el-option>
            <el-option :key="30" label="一个月" :value="30"> </el-option>
          </el-select>
        </el-form-item>
        <!-- <div v-if="isAdd != 'triall'">
          <el-form-item :label-width="formLabelWidth" label="支付方式" prop="pay_type">
            <el-radio-group v-model="form.pay_type">
              <el-radio :label="1">小智专用币优先</el-radio>
              <el-radio :label="2">通用币优先</el-radio>
            </el-radio-group>
          </el-form-item>
        </div> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form', (visible = false))">取 消</el-button>
        <!-- <el-button v-if="isAdd == 'triall'" class="primary" @click="triallClick">申请试用</el-button> -->
        <el-button class="primary" @click="buyClick">预览价格</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getXZEditions } from '@/api/auth';
import {
  getXZAuthList,
  buyXZ,
  addXZMonth,
  addXZMonthPrice,
  buyXZPrice,
  trailXZ,
  trialXZDelay,
  getXZLicense,
  getXZModuleList,
  addXZUserPrice,
  addXZUser,
  addXZMoudlePrice,
  addXZMoudle
} from '@/api/xzr_auth';
import { checkAgentPrice } from '@/api/agent';
import { payType } from '@/utils/dataDict';
import { payVerify } from '@/utils/pay';
import { getVersionOption, getseriesNameOption } from './utils';
export default {
  data() {
    const checkdomain = (rule, value, callback) => {
      let valid = true;
      for (let index = 0; index < this.auth_ips.length; index++) {
        const el = this.auth_ips[index];
        if (!el.value) {
          valid = false;
          break;
        }
      }
      if (!valid) {
        callback(new Error('IP/域名不能为空'));
      } else {
        callback();
      }
    };
    return {
      new_expire_time: '',
      modifyId: null,
      isAdd: 'add',
      currentBuyTime: null,
      payType,
      visible: false,
      formLabelWidth: '110px',
      form: {
        name: '', //用户名称
        contact_name: '', //联系人
        phone: '', // 固话
        email: '', // 电子邮箱
        // trail_days: 30, // 试用天数
        months: null,
        pay_type: 1,
        edition: '', // 版本
        // modules: [],
        domain: '', // ip
        internal_domain: '', // 内网ip
        note: '', // 备注
        grade: '',
        new_modules: ["api_base"],
        user_count: "",
        trail_days: 30,
        new_months: 1,
        buy_type: 1,


      },
      formRules: {
        name: [
          {
            required: true,
            message: '请输入授权客户名称',
            trigger: 'blur',
          },
        ],
        domain: [{ validator: checkdomain, trigger: 'blur' }],
        code: [
          {
            required: true,
            message: '请输入授权码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        key: [
          {
            required: true,
            message: '请输入授权码密码',
            trigger: 'blur',
          },
          {
            pattern: /^[0-9a-zA-Z]{1,}$/,
            message: '只支持输入数字、字母',
            trigger: 'blur',
          },
        ],
        contact_name: [
          {
            required: true,
            message: '请输入客户联系人',
            trigger: 'blur',
          },
        ],
        phone: [
          {
            required: true,
            message: '请输入联系人电话',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '请输入联系人邮箱',
            trigger: 'blur',
          },
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: 'blur',
          },
        ],
      },
      isSelectAll: false,
      modules: [],
      xzProducts: {},
      editions: [],
      buyTime: [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 },
        { name: '买断', value: 10000 },
      ],
      n_module: [
        // {
        //   "name": "小智API-标准",
        //   "value": "小智API-标准"
        // },
        // {
        //   "name": "小智API高级模块",
        //   "value": "小智API高级模块"
        // },
        // {
        //   "name": "小智报表标准模块",
        //   "value": "小智报表标准模块"
        // },
        // {
        //   "name": "小智报表高级模块",
        //   "value": "小智报表高级模块"
        // },
        // {
        //   "name": "小智BI基础模块",
        //   "value": "小智BI基础模块"
        // },
        // {
        //   "name": "小智BI高级模块",
        //   "value": "小智BI高级模块"
        // },
      ],
      moduleMapping: {
        // '小智BI高级模块': '小智BI基础模块',
        // '小智API高级模块': '小智API-标准',
        // '小智报表高级模块': '小智报表标准模块'
      },
      edittions: [],
      lockModuels: {}, //必须跟着版本购买的模块
      currentSelectModuels: [],
      productVersion: [],
      optionalVersion: {}, //根据产品选择可选版本
    };
  },
  mounted() {
    this.getUserInfo();
    this.getXZModuleListInfo();
  },
  methods: {
    addIP() {
      this.auth_ips.push({ value: '' });
    },
    modules_change(val) {
      console.log(val);
      if (!val.includes("api_base") && !this.form.new_modules.includes('api_base')) {
        this.form.new_modules.push("api_base");
      }
      for (const n_module of this.n_module) {
        for (const v of val) {
          if (n_module.value == v && n_module.dependency) {   // 去寻找依赖项
            if (!this.form.new_modules.includes(n_module.dependency)) {
              this.form.new_modules.push(n_module.dependency);
            }
            break
          }
        }
      }

    },
    getXZModuleListInfo() {
      getXZModuleList().then(res => {
        this.n_module = [{
          value: "api_base",
          name: "小智API-标准",
          dependency: ""
        }].concat(res.map(item => {
          return {
            value: item.code,
            name: item.name,
            dependency: item.code == "api_pro" ? "api_base" : item.dependency
          }
        }))
      });
    },
    addInternalIP() {
      this.Internal_auth_ips.push({ value: '' });
    },
    getUserInfo() {
      this.userInfo = this.$store.getters.userInfo;
    },
    removeIp(index) {
      this.auth_ips.splice(index, 1);
    },
    removeInternalIp(index) {
      this.Internal_auth_ips.splice(index, 1);
    },
    changeBuyDate() {
      this.accreditDate();
    },
    accreditDate() {
      let date = new Date(this.form.expire_time);
      if (this.isAdd != 'edit') {
        date = new Date();
        this.form.expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
          date.getDate(),
        )}`;
      }
      if (this.form.expire_time == '买断') {
        //过期时间为买断
        this.new_expire_time = '买断';
      } else if (this.form.expire_time && date >= new Date()) {
        //判断有过期时间并且在没过期时间范围内
        if (this.form.months === 0) {
          //购买时长为只购买模块
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
            date.getDate(),
          )}`;
        } else if (this.form.months === 10000) {
          //购买时长为买断
          this.new_expire_time = '买断';
        } else {
          //购买时长N(1)年
          date.setMonth(date.getMonth() + this.form.months);
          this.new_expire_time = `${date.getFullYear()}-${this.formatDate(date.getMonth() + 1)}-${this.formatDate(
            date.getDate(),
          )}`;
        }
      }
    },
    getBuyMonths(code) {
      if (!this.lockModuels[code]) {
        if (this.currentSelectModuels.indexOf(code) != -1) {
          if (this.form.expire_time) {
            let date = new Date(this.form.expire_time);
            let now = new Date();
            if (now < date) {
              //未过期
              return `${this.form.months}个月+补购${Math.floor((date - now) / 86400000)}天`;
            }
          }
        }
      }
      return this.form.months + '个月';
    },
    formatDate(num) {
      let result = num + '';
      if (result.length < 2) {
        result = '0' + result;
      }
      return result;
    },
    show(obj) {
      this.buyTime = [
        { name: '一年', value: 12 },
        { name: '两年', value: 24 },
        { name: '三年', value: 36 },
        { name: '买断', value: 10000 },
      ];
      this.visible = true;
      // if (this.isAdd == 'edit') {
      this.modifyId = obj.id;
      this.form.name = obj.name;
      this.form.code = obj.code;
      this.form.key = obj.key;
      this.form.edition = obj.edition;
      this.form.expire_time = obj.expire_time;
      this.form.new_modules = ['api_base'].concat(obj.modules) || [];
      this.form.trail_days = 30
      this.form.new_months = 1
      this.form.buy_type = 1
      // this.form.grade = obj.grade;
      // this.selectEditon(obj.grade);
      // } else if (this.isAdd == 'triall') {
      //   this.form.months = 30;
      // }
      this.getEditions();
    },
    triallClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            trail_days: this.form.months,
          };
          obj.name = this.form.name;
          obj.code = this.form.code;
          obj.key = this.form.key;
          obj.note = this.form.note;
          obj.phone = this.form.phone;
          obj.contact_name = this.form.contact_name;
          obj.email = this.form.email;
          obj.edition = 201;
          // obj.grade = this.form.grade;
          obj.modules = this.form.new_modules.filter(item => item !== "api_base");
          trailXZ(obj)
            .then(() => {
              this.loading = false;
              this.$message({
                type: 'success',
                message: '申请试用成功',
              });
              this.resetForm();
              this.$parent.getAuthData();
              this.visible = false;
              this.loading = false;
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    resetForm() {
      this.form = {
        name: '', //用户名称
        code: '', //授权码
        key: '', //授权码密码
        contact_name: '', //联系人
        phone: '', // 固话
        email: '', // 电子邮箱
        months: null,
        pay_type: 1,
        edition: '', // 版本
        grade: '',
        domain: '', // 外网ip
        internal_domain: '', // 内网ip
        note: '', // 备注
        new_modules: ["api_base"],
        user_count: "",
        trail_days: 30,
        new_months: 1,
        buy_type: 1,
      };
    },
    buyClick() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let obj = {
            // months: this.form.months,
            pay_type: this.form.pay_type,
          };
          if (this.isAdd == 'module') {
            // obj.name = this.form.name;
            // obj.code = this.form.code;
            // obj.key = this.form.key;
            // obj.contact_name = this.form.contact_name;
            // obj.phone = this.form.phone;
            // obj.email = this.form.email;
            // obj.edition = 201;
            // obj.note = this.form.note;
            let buyout = false
            if (this.form.buy_type == 1) {  //买断
              buyout = true
              this.form.months = 10000
            } else if (this.form.buy_type == 2) {
              buyout = false
              this.form.months = Number(this.form.new_months) * 12
            }
            obj.buyout = buyout
            obj.months = this.form.months;
            obj.modules = this.form.new_modules.filter(item => item !== "api_base");
            // obj.user_count = this.form.user_count;
            // this.modifyId = obj.id;
            this.buySubmit(obj, this.modifyId);
          } else if (this.isAdd == 'user') {
            obj.user_count = this.form.user_count;
            this.modifyBuySubmit(obj, this.modifyId);

          }
        }
      });
    },
    buySubmit(obj, id) {
      // let priceObj = {
      //   code: this.form.code,
      //   key: this.form.key,
      //   pay_type: this.form.pay_type,
      //   months: this.form.months,
      //   // edition: this.form.edition,
      //   modules: this.form.new_modules,
      //   user_count: this.form.user_count
      //   // grade: this.form.grade,
      // };
      addXZMoudlePrice(id, obj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.xz_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  addXZMoudle(id, obj).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '增购模块成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    modifyBuySubmit(obj, id) {
      // let priceObj = {
      //   pay_type: this.form.pay_type,
      //   months: this.form.months,
      // };
      addXZUserPrice(id, obj)
        .then((res) => {
          this.$store
            .dispatch('user/userinfo') //获取账户余额
            .then(() => {
              this.loading = false;
              let finance = {
                special: this.$store.getters.userInfo.finance.xz_point,
                universal: this.$store.getters.userInfo.finance.point,
              };
              let parms = {
                price: res.price,
                payType: this.form.pay_type,
              };
              let result = payVerify(parms, finance, '小智产品'); //检测余额是否足够
              this.$confirm(`${result.msg}，是否购买？`, '支付信息', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
              })
                .then(() => {
                  addXZUser(id, obj).then((res) => {
                    this.$message({
                      type: 'success',
                      message: '增购许可数成功!',
                    });
                    this.resetForm();
                    this.visible = false;
                    this.$parent.getAuthData();
                  });
                })
                .catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消购买',
                  });
                });
            });
        })
        .catch((err) => { });
    },
    restForm(done) {
      this.cancel();
      done();
    },
    cancel(formName, close) {
      this.resetForm();
      this.modifyId = null;
      this.isAdd = 'add';
    },
    checkSelctRow(row) {
      if (row.code == this.lockModuels[row.code]) {
        return false;
      } else {
        return true;
      }
    },
    selectChange(selection, row) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
    },
    selectAllChange(selection) {
      this.currentSelectModuels = selection.map((val) => {
        return val.code;
      });
    },
    changeMonths(item) {
      for (const e of this.editions) {
        if (e.value == item) {
          item = e;
          break;
        }
      }
      if (item.buyout_valid && item.valid) {
        this.buyTime = [
          { name: '一年', value: 12 },
          { name: '两年', value: 24 },
          { name: '三年', value: 36 },
          { name: '买断', value: 10000 },
        ];
      } else if (item.buyout_valid) {
        this.buyTime = [{ name: '买断', value: 10000 }];
      } else if (item.valid) {
        this.buyTime = [{ name: '一年', value: 12 }, { name: '两年', value: 24 }, { name: '三年', value: 36 }];
      }
    },
    /* 只保留api服务 */
    filterAPI(res) {
      const FILTER_EDITIONS = 201;
      return res.filter((i) => i.edition === FILTER_EDITIONS);
    },
    getEditions() {
      getXZEditions()
        .then((res) => {
          res = this.filterAPI(res);
          this.parseVersion(res);
          const newSetedition = [...new Set(res.map((i) => i.edition))];

          this.editions = [];
          newSetedition.forEach((item) => {
            this.editions.push(
              getseriesNameOption().find((i) => {
                return i.value === item;
              }),
            );
          });
        })
        .catch((err) => { });
    },
    parseVersion(data) {
      const result = {};
      data.forEach((item) => {
        if (result[item.edition]) {
          result[item.edition].push(item.grade);
        } else {
          result[item.edition] = [item.grade];
        }
      });
      this.optionalVersion = result;
    },
    selectEditon(value) {
      /* 编辑模式 */
      if (this.isAdd === 'edit') {
        this.productVersion = [
          { name: '免费版', value: 1 },
          { name: '标准版', value: 2 },
          { name: '高级版', value: 3 },
          { name: '旗舰版', value: 4 },
        ];
        return;
      }
      /* 添加模式 */
      this.form.grade = '';
      const result = [];
      this.optionalVersion[value].forEach((item) => {
        let option = getVersionOption().find((i) => i.value === item);
        if (option) {
          result.push(option);
        }
        this.productVersion = result;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.xz_buyDialog {
  div {
    // box-sizing: border-box;
  }

  .input_bottom {
    margin-bottom: 10px;
  }

  /deep/ .el-dialog__body {
    padding: 30px 20px 0px 20px !important;
  }

  .ip_valid:before {
    content: '*';
    color: #f56c6c;
    margin-right: 4px;
  }

  .ip_main {
    .ip_input_main {
      display: inline-block;
      width: 100%;

      .add_span {
        width: 80px;
        text-align: center;
        color: #409eff;
        cursor: pointer;

        i {
          font-size: 20px;
        }
      }
    }
  }

  .ip_main :not(:last-child) {
    margin-bottom: 10px;
  }

  .info {
    margin: 10px 5px;
    border: 1px solid rgb(233, 233, 233);
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.047) 0px 0px 5px;

    .input_box {
      padding: 0 50px;
      margin-top: 20px;

      // margin-bottom: 10px;
      .block {
        display: inline-block;
        margin-right: 85px !important;
        margin-top: 0 !important;
        margin-bottom: 10px !important;
        width: 178px;

        .autocomplete {
          width: 100%;
        }

        .el-form-item {
          margin-bottom: 0px;
        }
      }

      .block:last-child {
        margin-right: 0 !important;
      }

      .label {
        margin-bottom: 5px;
        font-size: 13px;

        span {
          color: #ff0000;
        }
      }
    }

    .title {
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
      border-bottom: 1px solid rgb(233, 233, 233);
      font-size: 16px;
      font-weight: 650;
      padding: 15px 20px;
      background: #f9f9f9;
    }
  }

  .company_info {
    padding-bottom: 20px;
  }

  .authorization_info {
    .context {
      padding: 20px 50px;

      p {
        font-size: 13px;
        margin-bottom: 5px;
      }
    }
  }

  .pay_info {
    padding-bottom: 20px;
  }

  .price {
    float: left;
    text-align: left;
    font-size: 16px;

    span {
      color: #ff0000;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/xzReport/addApiProduct.vue